






import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {AUTH_GET_CLIENT, AUTH_GET_COUNTRY} from '@/store/modules/authentication/types';
import {Client} from '@/store/modules/authentication/interfaces';
import {TupleDictionary} from '@/utils/tupleDictionary';
import {ClientEnum} from '@/enums/client.enum';
import {CountryEnum, CountryType} from '@/enums/country.enum';
import ReportPowerBiContainer from '@/modules/neodash/components/report-powerbi-container/report-powerbi-container.vue';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from '@/modules/neodash/containers/powerbi/pbi-dict-workspace-id';

@Component({
  name: 'PbiDncUnmetDemandSalesGapLatamPage',
  components: { ReportPowerBiContainer }
})
export default class PbiDncUnmetDemandSalesGapLatamPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;

  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum, CountryType], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    this.dictReports.set([ClientEnum.GM, CountryEnum.Chile], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'a244297b-f151-4d16-940d-8e01c0e9f80a' });
    this.dictReports.set([ClientEnum.GM, CountryEnum.Argentina], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '2d8085af-3f07-4d2c-954a-64967610bc91' });
    this.dictReports.set([ClientEnum.GM, CountryEnum.Peru], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '1beac67e-32d9-4f59-8590-1787194d1edb' });
    this.dictReports.set([ClientEnum.GM, CountryEnum.Colombia], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'b651a351-3986-434e-ad6c-f20be68485e2' });
    this.dictReports.set([ClientEnum.GM, CountryEnum.Equador], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: '05072224-de06-482b-bb99-8f0d3d79f299' });

    this.crrReport = this.dictReports.get([this.client.id, this.country]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - DNC - Unmet Demand & Sales Gap`);
  }
}
